import { clearCommand } from './clear';
import { helpCommand } from './help';
import { chuckNorrisCommand } from './chuckNorris';

export const commands = {
    '/clear': clearCommand,
    '/help': helpCommand,
    '/chuck': chuckNorrisCommand,
};

export const handleCommand = (input, setMessages, setIsChuckMode) => {
    const command = input.trim().toLowerCase();
    const commandHandler = commands[command];

    const userMessage = {
        id: Date.now() + Math.random(),
        sender: "user",
        text: input,
        displayText: input,
    };

    setMessages(prev => [...prev, userMessage]);

    if (commandHandler) {
        return commandHandler(setMessages, setIsChuckMode);
    }

    return false;
}; 